import styled from 'styled-components';

export const PathsWrapper = styled.svg`
    position: absolute;
    z-index: 0;
    fill: transparent;
    width: 100%;
    height: 100%;
`;
